import joi from 'joi';

import {
  type PathLookupEventTopic,
  pathLookupEventTopics,
} from '../pathLookup/PathLookupEvents';
import type { PathLookupEdgeSettings } from './EdgeSettings';
import type { PresetId } from './PresetId';
import { generateEdgeSettingsSchemas } from './generateEdgeSettingsSchema';

export interface PathLookupSettings {
  ignoredTopics: PathLookupEventTopic[];
  colorDetectedLoops: boolean;
}

export type PathLookupGraphEdgeSettings = PathLookupEdgeSettings;
export type PathLookupGraphEdgesSettings = PathLookupGraphEdgeSettings[];
/**
 * Exported as a list instead of working schema, use Joi.alternatives to make it working schema
 * or incorporate into member array via .items(...pathLookupEdgeSettingsSchemas)
 */
export const pathLookupEdgeSettingsSchemas =
  generateEdgeSettingsSchemas('pathLookupEdge');

export interface PathLookupGraphSettings {
  edges: PathLookupGraphEdgesSettings;
  pathLookup: PathLookupSettings;
}

export const pathLookupGraphSettingSchema = joi
  .array()
  .items(...pathLookupEdgeSettingsSchemas);

export const pathLookupSettingsSchema = joi.object().keys({
  ignoredTopics: joi
    .array()
    .items(joi.valid(...pathLookupEventTopics))
    .required(),
  colorDetectedLoops: joi.boolean().required(),
});

export const pathLookupGraphSettingsSchema = joi.object().keys({
  edges: pathLookupGraphSettingSchema.required(),
  pathLookup: pathLookupSettingsSchema.required(),
});

export interface PathLookupGraphPreset extends PathLookupGraphSettings {
  factory: boolean;
  id: PresetId;
  name: string;
}

export const pathLookupGraphPresetSchema = pathLookupGraphSettingsSchema.keys({
  factory: joi.boolean().required(),
  id: joi.string().required(),
  name: joi.string().required(),
});
